'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["namespace"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import classnames from 'classnames';
import TinymceToolbar from './TinymceToolbar';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledToolbar = styled(TinymceToolbar)(({
  theme
}) => ({
  paddingBlock: theme.space['0'],
  paddingInline: theme.space['200'],
  borderBottom: `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`
}));
class IframeToolbar extends Component {
  constructor() {
    super();
    this.handleIframeClick = this.handleIframeClick.bind(this);
  }
  componentDidMount() {
    this.props.editor.on('click', this.handleIframeClick);
  }
  componentWillUnmount() {
    this.props.editor.off('click', this.handleIframeClick);
  }
  handleIframeClick() {
    this.props.editor.editorContainer.click();
  }
  render() {
    const _this$props = this.props,
      {
        namespace
      } = _this$props,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const className = classnames('mce-toolbar', namespace);

    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsx(StyledToolbar, Object.assign({}, props, {
      className: className
    }));
  }
}
IframeToolbar.propTypes = {
  editor: PropTypes.object.isRequired,
  namespace: PropTypes.string
};
export default IframeToolbar;